/**
 * Add Widget Modal
 * Choose a widget type to add to the dashboard
 */

import { listWidgetTypes } from './widgetRegistry';

interface Props {
  onClose: () => void;
  onAdd: (type: string) => void;
  isPending: boolean;
}

export default function AddWidgetModal({ onClose, onAdd, isPending }: Props) {
  const widgetTypes = listWidgetTypes();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[80vh] overflow-auto">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-bold text-gray-900">Add Widget</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
              disabled={isPending}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <div className="p-6">
          <p className="text-sm text-gray-600 mb-6">
            Choose a widget type. You can configure it after adding.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {widgetTypes.map((wt) => (
              <button
                key={wt.type}
                onClick={() => onAdd(wt.type)}
                disabled={isPending}
                className="text-left p-4 border border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <div className="flex items-start gap-3">
                  <div className="text-3xl">{wt.icon}</div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-900">{wt.label}</h3>
                    <p className="text-sm text-gray-600 mt-1">{wt.description}</p>
                    <div className="text-xs text-gray-500 mt-2">Type: {wt.type}</div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>

        <div className="p-6 border-t border-gray-200 flex justify-end">
          <button
            onClick={onClose}
            disabled={isPending}
            className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-md disabled:opacity-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
